import { HighChartDataBase } from './high-chart-data-base';
import moment from "moment";
import { ClickDataPoint } from './click-notifier';
 
export class LineCategoryHighChartData extends HighChartDataBase { 
    public getHighChartOptions(): Object {
        let that = this;
        let options = {
            accessability: { enabled: false },
            chart: {
                type: 'line',
                height: this.chartHeight,
                zoomType: 'x',
                resetZoomButton: {
                    position: { x: 0, y: -45 }
                },
                panning: true,
                panKey: 'shift'
            },
            title: { 
                text: this.chartTitle,
                widthAdjust: -150,
                margin: 30
            },
            subtitle: { 
                text: this.chartSubTitle ,
                widthAdjust: -150
            },
            yAxis: this.getYAxis(),
            series: this.chartSeries,
            xAxis: {
                type: "category",
                categories: this.categories,
                title: { 
                    text: this.xAxisTitle 
                },
                labels: {
                    step: (document.getElementById("chart-wrapper") ? (document.getElementById("chart-wrapper").clientWidth > 750 ? (this.categories.length < 100 ? 1 : null) : null) : null),
                    rotation: this.xAxisLabelRotation,
                    style: {
                        fontSize: this.categories.length > 50 && this.categories.length < 100 ? '10px' : '11px'
                    },
                    formatter: function () {
                        for (var i = 0; i < that.categories.length; i++) {
                            if (that.categories[i] === this.value) {
                                let value = this.value;
                                if (moment(value, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
                                    value = moment(value).locale("sv").format("YYYY-MMM-DD");
                                }
                                if (that.xAxisColors && that.xAxisColors[i] != '')
                                    return '<span style="fill: ' + that.xAxisColors[i] + ';">' + value + '</span>';
                                else 
                                    return value;
                            }
                        }
                    }
                },
                min: Number.isNaN(this.xMinValue) ? null : this.xMinValue,
                max: Number.isNaN(this.xMaxValue) ? null : this.xMaxValue
            },
            plotOptions: {
                series: {
                    turboThreshold: 1000000
                },
                line: {
                    boostThreshold: 1000,
                    enableMouseTracking: true,
                    lineWidth: this.chartType == 'point' ? 0 : 2,
                    marker: {
                        enabled: this.chartType == 'point' ? true : null
                    },
                    point: {
                        events: {
                            click: function () {
                                if (that.clickNotifier) {
                                    that.clickNotifier.handleClick(new ClickDataPoint(this.category, this.series.name, this.y));
                                }
                            }
                        }
                    }
                }
            },
            tooltip: {
                formatter: function() { return that.getDefaultTooltipText(this, true); },
                shared: true,
                useHTML: true
            },
            colors: this.defaultColors,
            legend: {
                enabled: this.chartSeries.length > 1 ? true : false
            },
            credits: {
                text: this.credits,
                href: this.creditsLink
            },
            boost: {
                useGPUTranslations: true
            },
 
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: this.chartWidth
                    }
                }]
            },
 
            exporting: {
                filename: "diagram_" + this.chartTitle
            }
        };
        
        return options;
    }

    /**
     * Hämta Y-axlar
     */
    private getYAxis() {
        let firstYAxis = this.createYAxis(this.yAxisTitle, this.yAxisTitleColor, this.yMinValue, this.yMaxValue);
        if (!this.hasY2Axis) { 
            //Om det endast finns en y-axis
            return firstYAxis;
        }
        else {
            // Om det finns två y-axlar
            let yAxis = [];
            yAxis.push(firstYAxis);
            let secondYAxis = this.createYAxis(this.y2AxisTitle, this.y2AxisTitleColor, this.y2MinValue, this.y2MaxValue, true);
            yAxis.push(secondYAxis);
            return yAxis;
        }
    }
}
